import { render, staticRenderFns } from "./OrderSettlement.vue?vue&type=template&id=daf72974&scoped=true"
import script from "./OrderSettlement.vue?vue&type=script&lang=js"
export * from "./OrderSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf72974",
  null
  
)

export default component.exports